import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'flowbite-react';
import { HiOutlineExclamationCircle } from 'react-icons/hi';

function PopUpErr({ showPopUp }) {
  const { popUp, setPopUp } = showPopUp;

  return (
    <Modal
      show={popUp}
      size="md"
      popup
      dismissible
      onClose={setPopUp}
    >
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            Todos os campos devem estar corretamente preenchidos.
          </h3>
          <div className="flex justify-center gap-4">
            <Button
              data-testid="popup-button-close"
              color="failure"
              onClick={setPopUp}
            >
              Fechar
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

PopUpErr.propTypes = {
  showPopUp: PropTypes.shape({
    popUp: PropTypes.bool.isRequired,
    setPopUp: PropTypes.func.isRequired,
  }).isRequired,
};

export default PopUpErr;
